module.exports = __webpack_public_path__ + "static/media/sj.063d1a48.svg";